import { render, staticRenderFns } from "./CommodityListModal.vue?vue&type=template&id=2a61f812&scoped=true&"
import script from "./CommodityListModal.vue?vue&type=script&lang=js&"
export * from "./CommodityListModal.vue?vue&type=script&lang=js&"
import style0 from "./CommodityListModal.vue?vue&type=style&index=0&id=2a61f812&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61f812",
  null
  
)

export default component.exports